import { ColumnDef } from "@tanstack/react-table";
import { InAppPaymentProps } from "../../store/actionType";

export const InAppPaymentTableColumns: ColumnDef<InAppPaymentProps>[] = [
//   {
//     id: "slNo",
//     header: "Sl. Ngggo",
//     cell: ({ row }) => row.index + 1,
//   },
  {
    accessorKey: "Transaction Id",
    header: () => <span>Transaction Id</span>,
    cell: (info) => info.getValue(),
  },
  {
    accessorKey: "Product",
    header: () => <span>Product</span>,
    cell: (info) => info.getValue(),
  },
  {
    accessorKey: "Purchase Date",
    header: () => <span>Purchase Date</span>,
    cell: (info) => info.getValue(),
  },
  {
    accessorKey: "UserId",
    header: () => <span>UserId</span>,
    cell: (info) => info.getValue(),
  },
  {
    accessorKey: "MembershipDuration Id",
    header: () => <span>MembershipDurationId</span>,
    cell: (info) => info.getValue(),
  },
  {
    accessorKey: "Amount",
    header: () => <span>Amount</span>,
    cell: (info) => info.getValue(),
  },
  {
    accessorKey: "Status",
    header: () => <span>Status</span>,
    cell: (info) => info.getValue(),
  },
//   {
//     accessorKey: "BfsOrderNo",
//     header: () => <span>Order No</span>,
//     cell: (info) => info.getValue(),
//   },
//   {
//     accessorKey: "BfsRemitterBankId",
//     header: () => <span>Remitter Bank ID</span>,
//     cell: (info) => info.getValue(),
//   },
//   {
//     accessorKey: "BfsRemitterName",
//     header: () => <span>Remitter Name</span>,
//     cell: (info) => info.getValue(),
//   },
//   {
//     accessorKey: "BfsTxnAmount",
//     header: () => <span>Txn Amount</span>,
//     cell: (info) => info.getValue(),
//   },
//   {
//     accessorKey: "BfsTxnCurrency",
//     header: () => <span>Currency</span>,
//     cell: (info) => info.getValue(),
//   },
//   {
//     accessorKey: "MembershipDurationId",
//     header: () => <span>Membership Duration</span>,
//     cell: (info) => info.getValue(),
//   },
//   {
//     accessorKey: "UserId",
//     header: () => <span>User ID</span>,
//     cell: (info) => info.getValue(),
//   },
];

